import { Component, OnInit } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { Path, RoutePath } from "src/app/shared/model/enum";
import { CompaniesService } from "src/app/components/crm/companies/pages/companies/companies.service";

@Component({
  selector: "app-request-no-renderer",
  templateUrl: "./request-no-renderer.component.html",
  styleUrls: ["./request-no-renderer.component.scss"],
})
export class RequestNoRendererComponent
  implements OnInit, ICellRendererAngularComp
{
  params: any;
  enumPath = Path;
  routePath = RoutePath;
  constructor(public companiesService: CompaniesService) {}
  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
  }
  refresh(params: ICellRendererParams<any, any>): boolean {
    return false;
  }

  ngOnInit(): void {}

  changeRoute(params) {
    this.onClick(params);
  }
  onClick(params) {
    const customEvent = new CustomEvent("textCellClick", {
      detail: { data: this.params },
    });
    document.dispatchEvent(customEvent);
  }

  ngOnDestroy() {}
}
